import { 
  // LatLngLiteral, 
  latLng 
} from "leaflet";

import { 
    V1Clinic,
    SearchFilters,
    // SearchResult,
    // UnrankedClinicSearchResult
  } from "../types/v1_schemas";

// import {
//   ResultListFilters,
//   // eslint-disable-next-line unused-imports/no-unused-imports,
//   // TelehealthEnum
// } from "../types/search";

// import {
//   // eslint-disable-next-line unused-imports/no-unused-imports
//   SERVICE_CATEGORIES,
//   PAYMENT_TYPES,
//   ACCESSIBILITY_OPTIONS,
//   LANGUAGES
// } from "../types/care_provider";

// import {
//   compareDistance
// } from "./filters/distance";

// import {
//   isOpenOnSelectedDays
// } from "./filters/hours";

// import {
//   offersAnyTypesOfHelpNeeded
// } from "./filters/typeOfHelp";

// import {
//   meetsAnyFeePreference
// } from "./filters/feePreference";

// import {
//   meetsAccessibilityNeeds
// } from "./filters/accessibility";

// import {
//   supportsLanguages
// } from "./filters/languages";

// import {
//   servesAgeGroupV1
// } from "../utils/filters/ageV1";

import coloradoZipData from "../data/colorado_zip_data.json";

// import {
//   isWithinRadius
// } from "./filters/distance";

// import { supportsLanguages } from "./filters/languages";
// import { providesTelehealth } from "./filters/telehealth";
// import { supportsPopulationsServed } from "./filters/populationServed";

import {
  ZipSearchMetadata,
  ZipData,
} from "../types/search";

import {
  getDefaultRadius
} from "./filters/distance";

export const getZipSearchMetadata = (zip: string | null | undefined): ZipSearchMetadata => {
  if (zip === null || zip === undefined || zip.length !== 5) {
    return { isValidZip: false };
  } else if (zip !== null && zip !== undefined && zip.length === 5) {
    const data = (coloradoZipData as ZipData)[zip];
    if (!data) {
      return { isValidZip: false };
    }

    return {
      isValidZip: true,
      distanceSearchRadiusInMiles: getDefaultRadius(data),
      center: { lat: data.lat, lng: data.lng },
    };
  }

  return {isValidZip: false};
}

export const getDistanceToZipCenter = (
  zip: string | null,
  v1Clinic: V1Clinic
): number | undefined => {
  if (!zip) {
    return undefined;
  }
  const zipSearchMetadata = getZipSearchMetadata(zip);
  if (!zipSearchMetadata.isValidZip || !v1Clinic.latLng) {
    return undefined;
  }
  return latLng(zipSearchMetadata.center).distanceTo(v1Clinic.latLng);
};

// export const addSearchMetadata = (
//   v1Clinics: Array<V1Clinic>,
//   searchLocation: LatLngLiteral
// ): UnrankedClinicSearchResult[] =>
// v1Clinics.map((result) => ({
//     ...result,
//     distance: result.latLng
//       ? latLng(searchLocation).distanceTo(result.latLng)
//       : undefined,
//   }));


  
// export const getZipSearchMetadataV1 = (zip: string): ZipSearchMetadata => {
//   if (zip.length !== 5) {
//     return { isValidZip: false };
//   }
//   const data = (coloradoZipData as ZipData)[zip];
//   if (!data) {
//     return { isValidZip: false };
//   }
//   return {
//     isValidZip: true,
//     defaultRadiusMiles: getDefaultRadius(data),
//     center: { lat: data.lat, lng: data.lng },
//   };
// };

// export function applySearchFilters(
//   ClinicData: Array<V1Clinic>,
//   filters: SearchFilters
// ): SearchResult {
//   const {
//     // eslint-disable-next-line unused-imports/no-unused-vars
//     page,
//     // eslint-disable-next-line unused-imports/no-unused-vars
//     pageSize,
//     // eslint-disable-next-line unused-imports/no-unused-vars
//     language,
//     // eslint-disable-next-line unused-imports/no-unused-vars
//     displayNameFilter,
//     // eslint-disable-next-line unused-imports/no-unused-vars
//     accessibilitySupportIds,
//     // eslint-disable-next-line unused-imports/no-unused-vars
//     careSettingIds,
//     // eslint-disable-next-line unused-imports/no-unused-vars
//     languageIds,
//     // eslint-disable-next-line unused-imports/no-unused-vars
//     patientAgeGroupIds,
//     // eslint-disable-next-line unused-imports/no-unused-vars
//     paymentTypeIds,
//     // eslint-disable-next-line unused-imports/no-unused-vars
//     raeIds,
//     // eslint-disable-next-line unused-imports/no-unused-vars
//     serviceCategoryIds,
//     // eslint-disable-next-line unused-imports/no-unused-vars
//     serviceProvidedIds,
//     telehealthOption,
//     patientCommunityIds,
//     openSunday,
//     openMonday,
//     openTuesday,
//     openWednesday,
//     openThursday,
//     openFriday,
//     openSaturday,
//     distanceSearchZipCode,
//     distanceSearchRadiusInMiles: milesStr,
//     // hours,
//     // age,
//     // telehealth
//   } = filters;

//   const zipSearchMetadata = getZipSearchMetadata(distanceSearchZipCode);
//   if (!zipSearchMetadata.isValidZip) {
//     return {
//       results: [],
//     };
//   }
//   const miles =
//     (milesStr && parseInt(milesStr)) || zipSearchMetadata.distanceSearchRadiusInMiles;

//   console.log(`miles are ${miles}`);

//   // calculate distance, apply filters, & sort results by distance
//   //const results = addSearchMetadataV1(v1ClinicData as Array<any>, zipSearchMetadata.center)
//    const results = addSearchMetadata(ClinicData as Array<V1Clinic>, zipSearchMetadata.center)  
//     .filter(
//       (result:UnrankedClinicSearchResult) =>
//         isWithinRadius(result, miles) &&
//         offersAnyTypesOfHelpNeeded(result, SERVICE_CATEGORIES) &&
//         meetsAnyFeePreference(result, PAYMENT_TYPES) &&
//         meetsAccessibilityNeeds(result, ACCESSIBILITY_OPTIONS) &&
//         isOpenOnSelectedDays(
//           result, 
//           openSunday ? true : false, 
//           openMonday ? true : false, 
//           openTuesday ? true : false, 
//           openWednesday ? true : false, 
//           openThursday ? true : false, 
//           openFriday ? true : false, 
//           openSaturday ? true : false) &&
//         supportsLanguages(result, LANGUAGES) &&
//         // servesAgeGroup(result, age) &&
//         providesTelehealth(result, telehealthOption) &&
//         supportsPopulationsServed(result, patientCommunityIds)
//     )
//     .sort(compareDistance)
//     .map((result, idx:number) => {
//       return { ...result, searchRank: idx + 1 };
//     });

//   return { results };
// }

export function countOptionalSearchFiltersUsed(filters: SearchFilters): number {
  let count = 0;
  // pluck zip and miles out of filters
  const { distanceSearchZipCode, distanceSearchRadiusInMiles, ...optionalFilters } = filters;
  for (const [_filter_k, filter_v] of Object.entries(optionalFilters)) {
    if (filter_v.length !== 0) {
      count += 1;
    }
  }
  return count;
}

/**
 * Helper function to parse filter values from URL search params
 * @param searchParams
 * @returns Object containing search urls by name
//  */
export function getFiltersFromSearchParams(
  searchParams: URLSearchParams
): SearchFilters {
  const filters: SearchFilters = {

    page: searchParams.get("page") ?? "1",
    pageSize: searchParams.get("pageSize") ?? "20",
    language: searchParams.get("language") ?? "en",
    distanceSearchZipCode: searchParams.get("distanceSearchZipCode") ?? "",
    distanceSearchRadiusInMiles: searchParams.get("distanceSearchRadiusInMiles") ?? "",
    serviceCategoryIds: searchParams.getAll("serviceCategoryIds") as string[],
    paymentTypeIds: searchParams.getAll("paymentTypeIds") as string[],
    accessibilitySupportIds: searchParams.getAll("accessibilitySupportIds") as [],
    hours: searchParams.getAll("hours") as [],
    languageIds: searchParams.getAll("languageIds") as [],
    patientAgeGroupIds: searchParams.getAll("patientAgeGroupIds") as [],
    telehealthOptions: searchParams.getAll("telehealthOptions") as string[],
    patientCommunityIds: searchParams.getAll("patientCommunityIds") as [],
    openSunday:searchParams.get("openSunday") ?? "",
    openMonday:searchParams.get("openMonday") ?? "",
    openTuesday:searchParams.get("openTuesday") ?? "",
    openWednesday:searchParams.get("openWednesday") ?? "",
    openThursday:searchParams.get("openThursday") ?? "",
    openFriday:searchParams.get("openFriday") ?? "",
    openSaturday:searchParams.get("openSaturday") ?? "",
  };

  if (!filters.serviceCategoryIds) delete filters.serviceCategoryIds;
  if (!filters.paymentTypeIds) delete filters.paymentTypeIds;
  if (!filters.accessibilitySupportIds) delete filters.accessibilitySupportIds;
  if (!filters.hours) delete filters.hours;
  if (!filters.languageIds) delete filters.languageIds;
  if (!filters.patientAgeGroupIds) delete filters.patientAgeGroupIds;
  if (!filters.telehealthOptions) delete filters.telehealthOptions;
  if (!filters.patientCommunityIds) delete filters.patientCommunityIds;
  if (!filters.openSunday) delete filters.openSunday;
  if (!filters.openMonday) delete filters.openMonday;
  if (!filters.openTuesday) delete filters.openTuesday;
  if (!filters.openWednesday) delete filters.openWednesday;
  if (!filters.openThursday) delete filters.openThursday;
  if (!filters.openFriday) delete filters.openFriday;
  if (!filters.openSaturday) delete filters.openSaturday;

  return filters;
}


